import { ReactNode, useId } from 'react';
import { clsx } from '../functions.ts'
import './statistics.css'

export default function Statistics(props:{label: string, now: number, future: number | undefined, unit: string, info?: string, children: ReactNode}) {
  const has_future = !(props.future == null || props.future == 0);
  const id = useId();
  
  return (
     <div 
        className='statistics'
        aria-labelledby={id+'-label'}
        aria-description={
          `Aktueller Wert: ${props.future ? props.future?.toLocaleString('de') : "nicht definiert"}, Wert nach Sanierung: ${props.now.toLocaleString('de') || "nicht definiert"}`
        }
      >
      <div className='statistics__label' id={id+'-label'}>{props.label}</div>
      <div aria-hidden className='statistics__infos'>
        <div aria-hidden className={clsx('statistics__info-now', !has_future && 'statistics__info-now--single')}>{props.now.toLocaleString('de')}</div>
        {
          has_future && (<>
             <div aria-hidden className='statistics__info-triangle'></div>
             <div aria-hidden className='statistics__info-future'>{props.future?.toLocaleString('de')}</div>
          </>)
        }
        <div aria-hidden className='statistics__info-unit'>{props.unit}</div>
        {props.children ? props.children : []}
      </div>
      <div aria-hidden className="statistics-hint"dangerouslySetInnerHTML={{__html:props.info || ""}}></div>
     </div>
  )
}
